<template>
  <van-popup
    v-model="visible"
    :style="{
      width: '80%',
      maxWidth: '320px',
      borderRadius: '12px',
      background: '#ffffff',
    }"
    :overlay="true"
    :close-on-click-overlay="true"
    @click-overlay="onClose"
  >
    <div class="subscribe-prompt-popup">
      <!-- 右上角关闭按钮 -->
      <div class="close-btn-wrap" @click="onClose">
        <van-icon name="cross" size="16" color="#000000" />
      </div>

      <!-- 中央客服图标 -->
      <div class="icon-wrap">
        <img class="kefu-icon" src="@/assets/strategy/kefu.png" alt="kefu" />
      </div>

      <!-- 提示文字 -->
      <div class="text-wrap">
        <div class="text-line">
          <span class="normal-text">如需订阅，可联系您的</span>
          <span class="link-text" @click="onContact">专属客服</span>
          <span class="normal-text">，或</span>
        </div>
        <div class="text-line" style="margin-top: 6px;">
          <span class="link-text" @click="onPurchase">前往购买</span>
          <span class="normal-text" @click="onPurchase">服务器套餐</span>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Icon } from 'vant';

export default {
  name: "SubscribePromptPopup",
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.value,
    };
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    onClose() {
      this.visible = false;
      this.$emit("close");
    },
    onContact() {
      this.$emit("contact");
    },
    onPurchase() {
      this.$emit("purchase");
    }
  }
}
</script>

<style lang="less" scoped>
.subscribe-prompt-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 30px;
}

.close-btn-wrap {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}

.icon-wrap {
  margin-top: 40px;
  margin-bottom: 12px;
}

.kefu-icon {
  width: 64px;
  height: 64px;
  object-fit: cover;
}

.text-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
}

.text-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.normal-text {
  font-size: 16px;
  color: #333333;
}

.link-text {
  font-size: 16px;
  color: #0052D9;
  cursor: pointer;
}
</style>
